(function () {
  if (window.__ucOfferAnalyticsBound) return;
  window.__ucOfferAnalyticsBound = true;

  var eventNames = {
    modalOpen: 'ucBottleListModalOpened',
    quantity: {
      content: 'ucQuantitySelectedContent',
      modal: 'ucQuantitySelectedModal',
      sticky: 'ucQuantitySelectedSticky'
    },
    buyNow: {
      content: 'ucBuyNowContentClicked',
      modal: 'ucBuyNowModalClicked',
      sticky: 'ucBuyNowStickyClicked'
    }
  };

  var surfaceAliases = {
    'description-modal': 'modal'
  };

  var uniqueStorageKey = 'uc-offer-analytics-unique-v1';
  var uniqueEvents = {};
  try {
    uniqueEvents = JSON.parse(window.sessionStorage.getItem(uniqueStorageKey) || '{}');
  } catch (error) {
    uniqueEvents = {};
  }

  function scopeContext(scope) {
    var checked = scope ? scope.querySelector('input[data-uc-analytics-quantity]:checked') : null;
    var interactionSurface = scope ? scope.getAttribute('data-uc-analytics-surface') || 'content' : 'content';
    return {
      surface: surfaceAliases[interactionSurface] || interactionSurface,
      interactionSurface: interactionSurface,
      component: scope ? scope.getAttribute('data-uc-analytics-component') || null : null,
      quantity: checked ? Number(checked.value) : null,
      productId: scope ? scope.getAttribute('data-uc-product-id') || null : null,
      variantId: scope ? scope.getAttribute('data-uc-variant-id') || null : null,
      template: scope ? scope.getAttribute('data-uc-template') || null : null
    };
  }

  function emit(name, context) {
    if (!name) return;
    var payload = Object.assign({ event: name, timestamp: new Date().toISOString() }, context || {});
    if (Array.isArray(window.igEvents)) {
      window.igEvents.push(payload);
    } else if (window.igEvents && Array.isArray(window.igEvents.igEvents)) {
      window.igEvents.igEvents.push(payload);
    } else {
      window.igEvents = [payload];
    }
    window.dispatchEvent(new CustomEvent('uc:offer-analytics', { detail: payload }));
  }

  function emitUnique(name, context) {
    if (!name) return;
    var scope = context && context.productId ? context.productId : window.location.pathname;
    var key = name + ':' + scope;
    if (uniqueEvents[key]) return;
    uniqueEvents[key] = true;
    try {
      window.sessionStorage.setItem(uniqueStorageKey, JSON.stringify(uniqueEvents));
    } catch (error) {
      // In-memory deduplication remains active when storage is unavailable.
    }
    emit(name, context);
  }

  function productPageContext(element, surface) {
    var modal = element ? element.closest('.uc-modal') : null;
    var scope = modal ? modal.querySelector('[data-qty-scope]') : null;
    if (!scope) scope = document.querySelector('[data-qty-scope][data-uc-product-id]');
    var context = scopeContext(scope);
    context.surface = surface;
    context.pagePath = window.location.pathname;
    return context;
  }

  function proofContext(element) {
    var grid = element ? element.closest('uc-proof-card-grid') : null;
    var cell = element ? element.closest('[data-proof-card-slot]') : null;
    return {
      surface: 'social-proof-cards',
      productId: grid ? grid.getAttribute('data-uc-product-id') || null : null,
      template: grid ? grid.getAttribute('data-uc-template') || null : null,
      cardSlot: cell ? Number(cell.getAttribute('data-proof-card-slot')) : null,
      metric: cell ? cell.getAttribute('data-proof-feature') || null : null,
      pagePath: window.location.pathname
    };
  }

  var cardFeatureEventNames = {
    purchasers: 'Purchasers',
    units: 'UnitsOrdered',
    purchase: 'RecentPurchase',
    upgrade: 'RecentUpgrade',
    repeat_purchasers: 'RepeatPurchasers',
    popular_quantity: 'PopularQuantity',
    returning_share: 'ReturningShare',
    upgrade_value: 'UpgradeValue',
    double_up: 'DoubleUp'
  };

  function cardEventName(metric, action) {
    var metricName = cardFeatureEventNames[metric];
    if (!metricName) return null;
    return 'ucSocialProof' + metricName + 'Card' + action;
  }

  var hoverTimers = new WeakMap();

  document.addEventListener('pointerover', function (event) {
    if (!event.isTrusted || (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen')) return;
    var cell = event.target.closest('[data-proof-card-slot]');
    if (!cell || (event.relatedTarget && cell.contains(event.relatedTarget))) return;
    window.clearTimeout(hoverTimers.get(cell));
    hoverTimers.set(cell, window.setTimeout(function () {
      var context = proofContext(cell);
      emitUnique(cardEventName(context.metric, 'Hovered'), context);
      hoverTimers.delete(cell);
    }, 350));
  }, true);

  document.addEventListener('pointerout', function (event) {
    var cell = event.target.closest('[data-proof-card-slot]');
    if (!cell || (event.relatedTarget && cell.contains(event.relatedTarget))) return;
    window.clearTimeout(hoverTimers.get(cell));
    hoverTimers.delete(cell);
  }, true);

  document.addEventListener('pointerdown', function (event) {
    if (!event.isTrusted || event.isPrimary === false) return;
    var cell = event.target.closest('[data-proof-card-slot]');
    if (cell) {
      var context = proofContext(cell);
      context.pointerType = event.pointerType || 'mouse';
      emitUnique(cardEventName(context.metric, 'Pressed'), context);
    }

    var marquee = event.target.closest('[data-deal-social-proof]:not(.deal-social-proof--media-overlay)');
    if (!marquee) return;
    var marqueeContext = {
      surface: 'social-proof-marquee',
      pointerType: event.pointerType || 'mouse',
      productId: marquee.getAttribute('data-uc-product-id') || null,
      pagePath: window.location.pathname
    };
    emitUnique(
      event.pointerType === 'touch' ? 'ucSocialProofMarqueeTouchPressed' : 'ucSocialProofMarqueeMousePressed',
      marqueeContext
    );
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var cell = event.target.closest('[data-proof-card-slot]');
    if (!cell) return;
    var context = proofContext(cell);
    emitUnique(cardEventName(context.metric, 'Clicked'), context);
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var zoomButton = event.target.closest('[data-uc-product-media-zoom]');
    if (!zoomButton) return;
    emitUnique('ucProductMediaImageZoomOpened', {
      surface: 'new-deal-card-media',
      productId: zoomButton.getAttribute('data-uc-product-id') || null,
      mediaId: zoomButton.getAttribute('data-media-id') || null,
      template: zoomButton.getAttribute('data-uc-template') || null,
      pagePath: window.location.pathname
    });
  }, true);

  document.addEventListener('wheel', function (event) {
    if (!event.isTrusted) return;
    var marquee = event.target.closest('[data-deal-social-proof]:not(.deal-social-proof--media-overlay)');
    if (!marquee) return;
    emitUnique('ucSocialProofMarqueeScrolled', {
      surface: 'social-proof-marquee',
      productId: marquee.getAttribute('data-uc-product-id') || null,
      pagePath: window.location.pathname
    });
  }, { capture: true, passive: true });

  function initialiseProofRails(root) {
    var grids = [];
    if (root && root.matches && root.matches('uc-proof-card-grid')) grids.push(root);
    if (root && root.querySelectorAll) grids = grids.concat(Array.from(root.querySelectorAll('uc-proof-card-grid')));

    grids.forEach(function (grid) {
      if (grid.getAttribute('data-uc-analytics-bound') === 'true') return;
      var track = grid.querySelector('.uc-proof-cards__track');
      if (!track) return;
      grid.setAttribute('data-uc-analytics-bound', 'true');
      var interacted = false;

      var context = function () {
        return {
          surface: 'social-proof-rail',
          productId: grid.getAttribute('data-uc-product-id') || null,
          template: grid.getAttribute('data-uc-template') || null,
          pagePath: window.location.pathname
        };
      };

      var finalCardIsFullyVisible = function () {
        if (!interacted || track.scrollWidth <= track.clientWidth + 1) return false;
        var cells = Array.from(track.children).filter(function (cell) {
          return cell.querySelector('uc-social-proof:not([hidden])');
        });
        var lastCell = cells[cells.length - 1];
        if (!lastCell) return false;
        var railRect = track.getBoundingClientRect();
        var cardRect = lastCell.getBoundingClientRect();
        return cardRect.left >= railRect.left - 1 && cardRect.right <= railRect.right + 1;
      };

      track.addEventListener('pointerdown', function (event) {
        if (event.isTrusted) interacted = true;
      }, { passive: true });
      track.addEventListener('wheel', function (event) {
        if (event.isTrusted) interacted = true;
      }, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.isTrusted && ['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) interacted = true;
      });
      track.addEventListener('click', function (event) {
        if (!event.isTrusted) return;
        emitUnique('ucSocialProofRailClicked', context());
      });
      track.addEventListener('scroll', function (event) {
        if (!event.isTrusted || !interacted) return;
        emitUnique('ucSocialProofRailScrolled', context());
        window.requestAnimationFrame(function () {
          if (finalCardIsFullyVisible()) emitUnique('ucSocialProofLastCardFullyViewed', context());
        });
      }, { passive: true });
    });
  }

  function bottleListLastItemIsFullyVisible(modal) {
    if (!modal || modal.getAttribute('aria-hidden') !== 'false') return false;
    var body = modal.querySelector('.uc-modal__body--bottle-list');
    var list = body ? body.querySelector('.uc-bottle-list') : null;
    if (!body || !list || body.scrollHeight <= body.clientHeight + 1) return false;
    var items = list.querySelectorAll('.uc-bottle-list__item');
    var lastItem = items[items.length - 1];
    if (!lastItem) return false;
    var viewportRect = body.getBoundingClientRect();
    var itemRect = lastItem.getBoundingClientRect();
    return itemRect.top >= viewportRect.top - 1 && itemRect.bottom <= viewportRect.bottom + 1;
  }

  function checkBottleListEnd(modal) {
    if (!bottleListLastItemIsFullyVisible(modal)) return;
    var context = productPageContext(modal, 'bottle-list-modal');
    context.itemCount = modal.querySelectorAll('.uc-bottle-list__item').length;
    emitUnique('ucBottleListLastItemFullyViewed', context);
  }

  function initialiseBottleLists(root) {
    var modals = [];
    if (root && root.matches && root.matches('.uc-modal[data-uc-modal-kind="bottle-list"]')) modals.push(root);
    if (root && root.querySelectorAll) {
      modals = modals.concat(Array.from(root.querySelectorAll('.uc-modal[data-uc-modal-kind="bottle-list"]')));
    }

    modals.forEach(function (modal) {
      if (modal.getAttribute('data-uc-bottle-list-analytics-bound') === 'true') return;
      var body = modal.querySelector('.uc-modal__body--bottle-list');
      if (!body) return;
      modal.setAttribute('data-uc-bottle-list-analytics-bound', 'true');
      var ticking = false;
      body.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          checkBottleListEnd(modal);
        });
      }, { passive: true });
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('input[data-uc-analytics-quantity]');
    if (!input || !event.isTrusted || !input.checked || input.disabled) return;
    var scope = input.closest('[data-qty-scope]');
    var context = scopeContext(scope);
    context.quantity = Number(input.value);
    emit(eventNames.quantity[context.surface], context);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-uc-analytics-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    var scope = button.closest('[data-qty-scope]');
    var context = scopeContext(scope);
    emit(eventNames.buyNow[context.surface], context);
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var modalButton = event.target.closest('[data-uc-modal-jump-top]');
    if (modalButton) {
      emitUnique('ucBottleListModalBackToTopPressed', productPageContext(modalButton, 'bottle-list-modal'));
      return;
    }
    var pageButton = event.target.closest('[data-uc-jump-top]');
    if (pageButton) emitUnique('ucPdpBackToTopPressed', productPageContext(pageButton, 'main-pdp'));
  }, true);

  window.addEventListener('uc:bottle-list-modal-open', function (event) {
    var detail = event.detail || {};
    var modal = detail.modalId ? document.getElementById(detail.modalId) : null;
    var scope = modal ? modal.querySelector('[data-qty-scope]') : null;
    var context = scopeContext(scope);
    context.modalId = detail.modalId || null;
    context.source = detail.source || 'generic';
    emit(eventNames.modalOpen, context);
    if (modal) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { checkBottleListEnd(modal); });
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseProofRails(document);
      initialiseBottleLists(document);
    }, { once: true });
  } else {
    initialiseProofRails(document);
    initialiseBottleLists(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialiseProofRails(event.target);
    initialiseBottleLists(event.target);
  });
})();
